import type { Release } from '../shared/types'

/** Klinik buildinfo sürümüyle aynı biçim; kurulum heartbeat'te bunu bildirir. */
export const VERSION_RE = /^\d+\.\d+\.\d+(-[0-9A-Za-z.-]+)?$/
export const MAX_NOTES = 8000

/** Yayımlanabilir: imaj işi, digest kayıtlı, imza doğrulanmış ve henüz yayımlanmamış. */
export const publishable = (r: Release) =>
  r.job_type === 'image' && !!r.image_digest && !!r.cosign_verified && !r.published_at
